










































































import {Component, Prop, Vue} from "vue-property-decorator";

import CopyClickWrapper from "@/views/components/CopyClickWrapper.vue";
import {IActiveShipment} from "@/models/StoreModels";
import {ACTIVE_SHIPMENT_TYPE} from "@/constants/orders";
import {namespace} from "vuex-class";
import {ShipmentLogic} from "@/models/ShipmentLogic";
import ShowOneHub from '@/views/components/Home/dropup/ShowOneHub.vue';
import UserPhoneDataPair from "@/views/components/PairData/UserPhoneDataPair.vue";
import ShipmentTypeDataPair from "@/views/components/PairData/ShipmentTypeDataPair.vue";
import DataPair from "@/views/components/PairData/DataPair.vue";
import VueI18n from "vue-i18n";
import {HISTORY, OTHER_ROUTES} from "@/constants/routes";
import LocaleMessage = VueI18n.LocaleMessage;

const userDataModule = namespace('userData');
const hubsModule = namespace('hubs');

@Component({
  name: "ShipmentInfo",
  components: {
    CopyClickWrapper,
    ShowOneHub,
    UserPhoneDataPair,
    ShipmentTypeDataPair,
    DataPair,
  },
})
export default class ShipmentInfo extends Vue {
  @userDataModule.Getter('getId')
  private userId!: number;

  @userDataModule.Getter('userSmsWasValidated')
  private userSmsWasValidated!: boolean;

  @hubsModule.Getter('getHubAddressById')
  private getHubAddressById!: (id: string|number) => string;

  @Prop()
  private shipment!: IActiveShipment;

  private isMapVisible: boolean = false;

  private close() {
    this.$emit("dialog:clickClose");
  }

  private get showShipmentAddress() {
    return ShipmentLogic.destinationHubIsValid(this.shipment) &&
           !ShipmentLogic.userIsCrosstownSender(this.shipment, this.userId);
  }

  private get destinationHubAddress(): string {
    return this.shipment.to_hub_id ? this.getHubAddressById(this.shipment.to_hub_id) : '-';
  }

  private showMap() {
    this.isMapVisible = true;
  }

  private hideMap() {
    this.isMapVisible = false;
  }

  private get showButton(): boolean {
    return !this.shipmentIsCompleted && (this.userIsSenderAndMustOpenHub ||
        this.userIsRecipientAndMustOpenHub ||
        this.userIsRecipientAndMustSelectHub);
  }

  private openHub() {
    this.close();
    if (this.userIsRecipientAndMustOpenHub) {
      if (this.userSmsWasValidated) {
        this.$router.push({name: OTHER_ROUTES.PICKUP_ITEM, params: { asId: `${this.shipment.id}` } });
      } else {
        this.$uiBus.emit('genericError:show', this.$t('errors.validation'));
      }
    } else {
      this.$router.push({name: OTHER_ROUTES.DEPOSIT_ITEM, params: { asId: `${this.shipment.id}` } });
    }
  }

  private isHistoryRoute() {
    return this.$route.name === HISTORY.SHIPMENT || this.$route.name === HISTORY.START;
  }

  private selectHubRecipientIfValidated() {
    let myPromise: Promise<any> = Promise.resolve();

    if (this.isHistoryRoute()) {
      myPromise = this.$router.push({ name: OTHER_ROUTES.HOME });
    } else {
      this.close();
    }

    myPromise.then(() => this.$uiBus.emit("dropup:openSelectDestination", this.shipment.id));
  }

  private selectHubRecipient() {
    if (this.userSmsWasValidated) {
      this.selectHubRecipientIfValidated();
    } else {
      this.$uiBus.emit('genericError:show', this.$t('errors.validation'));
    }
  }

  private get shipmentIsCompleted(): boolean {
    return ShipmentLogic.isCompleted(this.shipment);
  }

  private get userIsSenderAndMustOpenHub(): boolean {
    return ShipmentLogic.isAwaitingDropoff(this.shipment) &&
        ShipmentLogic.userIsSender(this.shipment, this.userId);
  }

  private get userIsRecipientAndMustOpenHub(): boolean {
    return ShipmentLogic.isAwaitingPickup(this.shipment) &&
        ShipmentLogic.userIsRecipient(this.shipment, this.userId);
  }

  private get userIsRecipientAndMustSelectHub(): boolean {
    return !ShipmentLogic.destinationHubIsValid(this.shipment) &&
        ShipmentLogic.userIsRecipient(this.shipment, this.userId) &&
        !ShipmentLogic.isAwaitingDropoff(this.shipment);
  }

  private get userIsSenderWaitingForRecipientAction(): boolean {
    return ShipmentLogic.userIsSender(this.shipment, this.userId) &&
        ShipmentLogic.isAwaitingPickup(this.shipment);
  }

  // this is not showing by now but it might in the future
  private get userIsRecipientWaitingForSenderAction(): boolean {
    return ShipmentLogic.userIsRecipient(this.shipment, this.userId) &&
        ShipmentLogic.isAwaitingDropoff(this.shipment);
  }

  private get readableStatusCallToAction(): LocaleMessage {
    if (ShipmentLogic.isCompleted(this.shipment)) {
      return this.$t('status.completed');
    }

    if (this.userIsSenderAndMustOpenHub) {
      return this.$t('statusCallToAction.awaitingDropoffSender');
    }

    if (this.userIsRecipientAndMustOpenHub) {
      return this.$t('statusCallToAction.awaitingPickupRecipient');
    }

    if (this.userIsRecipientAndMustSelectHub) {
      return this.$t('statusCallToAction.awaitingHubSelectionRecipient');
    }

    if (this.userIsRecipientWaitingForSenderAction) {
      return this.$t('status.waitingActionSender');
    }

    if (this.userIsSenderWaitingForRecipientAction) {
      return this.$t('status.waitingActionRecipient');
    }

    return this.$t('status.inProgress');
  }

  private get readableStatus(): LocaleMessage {
    if (ShipmentLogic.isAwaitingDropoff(this.shipment)) {
      return this.$t('status.waitingActionSender');
    }

    if (ShipmentLogic.isAwaitingPickup(this.shipment)) {
      return this.$t('status.readyToPickUp');
    }

    if (ShipmentLogic.isToBeDelivered(this.shipment) && !ShipmentLogic.destinationHubIsValid(this.shipment)) {
      // todo: for "send to a friend" type, the sender will read this if the recipient has a favorite hub (and can't
      // choose a hub, so the correct status should be "in Progress" in that situation
      return this.$t('status.waitingActionRecipient');
    }

    if (ShipmentLogic.isToBeDelivered(this.shipment)) {
      return this.$t('status.inProgress');
    }

    if (ShipmentLogic.isCompleted(this.shipment)) {
      return this.$t('status.completed');
    }

    return this.$t('status.inProgress');
  }

}
